var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _g3, _path42, _path43, _path44, _g4, _path45, _path46, _path47, _path48, _g5, _path49, _path50, _path51, _g6, _path52, _path53, _path54, _g7, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g8, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g9, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g10, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g11, _path127, _path128, _path129, _path130, _g12, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _g13, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _g14, _path175, _path176, _path177, _path178, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.84 138.4C158.36 146.696 152.44 105.48 107.512 109.888C70.4881 113.48 35.6401 167.304 43.6401 210.4C53.2401 262.136 96.9121 296.168 126.84 296.456C160.44 296.792 179.264 278.856 210.576 267.944C246.84 255.288 302.808 263.256 332.704 237.464C361.504 212.624 365.68 149.2 349.4 114.92C333.24 80.8884 293.24 47.8244 256.976 64.4564C217.232 82.6964 218.576 126.24 182.84 138.4Z",
    fill: "url(#paint0_linear_989_5329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M182.84 138.4C158.36 146.696 152.44 105.48 107.512 109.888C70.4881 113.48 35.6401 167.304 43.6401 210.4C53.2401 262.136 96.9121 296.168 126.84 296.456C160.44 296.792 179.264 278.856 210.576 267.944C246.84 255.288 302.808 263.256 332.704 237.464C361.504 212.624 365.68 149.2 349.4 114.92C333.24 80.8884 293.24 47.8244 256.976 64.4564C217.232 82.6964 218.576 126.24 182.84 138.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5762 312.32H365.424",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.592 339.64C265.636 339.64 316.744 336.327 316.744 332.24C316.744 328.153 265.636 324.84 202.592 324.84C139.548 324.84 88.4399 328.153 88.4399 332.24C88.4399 336.327 139.548 339.64 202.592 339.64Z",
    fill: "url(#paint1_linear_989_5329)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0244 177.472C51.0244 177.472 63.4964 192.08 66.6564 225.944C69.8164 259.808 73.4644 284.504 73.4644 284.504",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2802 150.744C30.8119 150.686 30.3392 150.807 29.9565 151.083C29.5738 151.359 29.3094 151.769 29.2162 152.232C27.3682 161.632 19.3762 206.832 38.1122 200.872C53.6562 195.928 52.6402 184.552 51.0962 179.056C51.0242 178.799 51.026 178.528 51.1014 178.272C51.1768 178.017 51.3227 177.788 51.5223 177.611C51.722 177.435 51.9673 177.319 52.2302 177.276C52.493 177.232 52.7626 177.264 53.0082 177.368C59.0722 179.872 72.2642 183.816 73.7202 171.432C75.4002 157.168 39.6242 151.8 31.2802 150.744Z",
    fill: "url(#paint2_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1123 158.968C41.8522 163.228 45.1143 167.885 47.8403 172.856",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.416 153.392C33.5704 154.326 34.6684 155.327 35.704 156.392",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4004 175.999C46.4004 175.999 41.1764 170.511 28.3604 172.879",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1201 157.432C53.5641 162.472 53.5641 167.816 52.1201 172.856",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.584 186.848C29.7605 187.562 29.0198 188.368 28.376 189.248",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8403 180.695C47.8403 180.695 39.2003 181.135 32.8003 185.199",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9683 176C54.9683 176 64.6963 173.12 67.0723 165.168",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.104 226.512C86.104 226.512 78.976 234.864 77.168 254.232C75.36 273.6 73.272 287.728 73.272 287.728",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7283 212.079C96.9973 212.046 97.269 212.116 97.4887 212.275C97.7084 212.433 97.8597 212.67 97.9123 212.935C98.9683 218.303 103.512 244.135 92.8243 240.751C83.9363 237.919 84.5203 231.415 85.4003 228.271C85.4468 228.124 85.4496 227.966 85.4082 227.817C85.3667 227.668 85.2829 227.534 85.1669 227.431C85.0509 227.329 84.9077 227.262 84.7545 227.24C84.6014 227.217 84.445 227.239 84.3043 227.303C80.8403 228.743 73.2963 230.991 72.4643 223.911C71.5043 215.751 92.0003 212.687 96.7283 212.079Z",
    fill: "url(#paint3_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8002 216.8C90.6507 219.237 88.7729 221.9 87.2002 224.744",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0882 213.6C95.4238 214.133 94.7932 214.708 94.2002 215.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0723 226.512C88.0723 226.512 91.0643 223.368 98.3923 224.728",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8 215.903C83.9775 218.779 83.9775 221.828 84.8 224.703",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1279 232.728C97.5999 233.134 98.0239 233.593 98.3919 234.096",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2563 229.208C87.2563 229.208 92.1843 229.464 95.8563 231.784",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2003 226.512C83.2003 226.512 77.6003 224.864 76.2803 220.312",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4644 218.728C52.4644 218.728 63.9684 232.208 66.8644 263.464C67.8164 273.352 68.8004 282.4 69.6724 290.128",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6002 208.888C30.2531 209.007 29.9638 209.253 29.7903 209.576C29.6167 209.899 29.5717 210.276 29.6642 210.632C31.5762 217.832 41.4162 252.048 52.4402 241.512C61.6002 232.76 57.0082 225.176 54.0402 221.872C53.9031 221.718 53.8119 221.529 53.7773 221.326C53.7427 221.123 53.766 220.914 53.8445 220.724C53.923 220.534 54.0535 220.369 54.2211 220.25C54.3887 220.13 54.5866 220.06 54.7922 220.048C59.8722 219.728 70.4162 217.976 67.2162 208.848C63.5442 198.328 36.8002 206.784 30.6002 208.888Z",
    fill: "url(#paint4_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.6002 208.888C30.2531 209.007 29.9638 209.253 29.7903 209.576C29.6167 209.899 29.5717 210.276 29.6642 210.632C31.5762 217.832 41.4162 252.048 52.4402 241.512C61.6002 232.76 57.0082 225.176 54.0402 221.872C53.9031 221.718 53.8119 221.529 53.7773 221.326C53.7427 221.123 53.766 220.914 53.8445 220.724C53.923 220.534 54.0535 220.369 54.2211 220.25C54.3887 220.13 54.5866 220.06 54.7922 220.048C59.8722 219.728 70.4162 217.976 67.2162 208.848C63.5442 198.328 36.8002 206.784 30.6002 208.888Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1602 212.287C42.2224 213.993 46.0855 216.139 49.6802 218.687",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2881 210.344C33.4109 210.601 34.517 210.927 35.6001 211.32",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.752 221.319C49.752 221.319 44.24 219.271 36.104 225.319",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4004 206.447C50.1262 209.467 51.9475 213.193 52.6564 217.199",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4004 234.304C42.069 235.074 41.8248 235.879 41.6724 236.704",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3522 224.119C52.3522 224.119 46.4962 227.367 43.4082 232.391",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7124 218.4C55.7124 218.4 61.5124 213.072 60.4564 206.72",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8004 312.32H65.2164C63.0508 312.319 60.9676 311.49 59.3938 310.002C57.82 308.515 56.8749 306.482 56.7524 304.32L55.5684 281.472H86.4564L85.2724 304.32C85.1478 306.482 84.201 308.516 82.6259 310.003C81.0509 311.49 78.9667 312.319 76.8004 312.32Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M246.152 277.768C246.376 275.6 252.456 217.768 252.688 215.576C252.894 213.884 253.703 212.323 254.967 211.18C256.23 210.036 257.864 209.387 259.568 209.352H349.712L341.864 284H251.72C250.926 284.016 250.139 283.86 249.411 283.543C248.683 283.226 248.032 282.756 247.503 282.164C246.974 281.572 246.58 280.872 246.346 280.114C246.113 279.355 246.047 278.554 246.152 277.768Z",
    fill: "url(#paint5_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 209,
    width: 104,
    height: 76
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M246.152 277.768C246.376 275.6 252.456 217.768 252.688 215.576C252.894 213.884 253.703 212.323 254.967 211.18C256.23 210.036 257.864 209.387 259.568 209.352H349.712L341.864 284H251.72C250.926 284.016 250.139 283.86 249.411 283.543C248.683 283.226 248.032 282.756 247.503 282.164C246.974 281.572 246.58 280.872 246.346 280.114C246.113 279.355 246.047 278.554 246.152 277.768Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M246.152 277.768C246.376 275.6 252.456 217.768 252.688 215.576C252.894 213.884 253.703 212.323 254.967 211.18C256.23 210.036 257.864 209.387 259.568 209.352H349.712L341.864 284H251.72C250.926 284.016 250.139 283.86 249.411 283.543C248.683 283.226 248.032 282.756 247.503 282.164C246.974 281.572 246.58 280.872 246.346 280.114C246.113 279.355 246.047 278.554 246.152 277.768Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M246.152 277.768C246.376 275.6 252.456 217.768 252.688 215.576C252.894 213.884 253.703 212.323 254.967 211.18C256.23 210.036 257.864 209.387 259.568 209.352H349.712L341.864 284H251.72C250.926 284.016 250.139 283.86 249.411 283.543C248.683 283.226 248.032 282.756 247.503 282.164C246.974 281.572 246.58 280.872 246.346 280.114C246.113 279.355 246.047 278.554 246.152 277.768Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M341.856 224.8C342.4 219.632 342.776 216.08 342.832 215.568C343.037 213.876 343.846 212.315 345.11 211.172C346.374 210.028 348.008 209.379 349.712 209.344C350.507 209.323 351.298 209.475 352.029 209.789C352.76 210.104 353.414 210.573 353.947 211.164C354.479 211.756 354.877 212.456 355.112 213.216C355.348 213.976 355.416 214.779 355.312 215.568C355.032 218.248 349.055 275.08 348.775 277.76C348.57 279.452 347.761 281.014 346.498 282.159C345.234 283.303 343.6 283.954 341.895 283.992C341.1 284.011 340.309 283.858 339.578 283.543C338.846 283.228 338.192 282.758 337.66 282.165C337.128 281.573 336.73 280.873 336.495 280.112C336.259 279.352 336.191 278.549 336.295 277.76C336.455 276.264 339.392 248.32 341.28 230.384",
    fill: "url(#paint6_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 336,
    y: 209,
    width: 20,
    height: 75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M341.856 224.8C342.4 219.632 342.776 216.08 342.832 215.568C343.037 213.876 343.846 212.315 345.11 211.172C346.374 210.028 348.008 209.379 349.712 209.344C350.507 209.323 351.298 209.475 352.029 209.789C352.76 210.104 353.414 210.573 353.947 211.164C354.479 211.756 354.877 212.456 355.112 213.216C355.348 213.976 355.416 214.779 355.312 215.568C355.032 218.248 349.055 275.08 348.775 277.76C348.57 279.452 347.761 281.014 346.498 282.159C345.234 283.303 343.6 283.954 341.895 283.992C341.1 284.011 340.309 283.858 339.578 283.543C338.846 283.228 338.192 282.758 337.66 282.165C337.128 281.573 336.73 280.873 336.495 280.112C336.259 279.352 336.191 278.549 336.295 277.76C336.455 276.264 339.392 248.32 341.28 230.384",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.832 215.575C343.037 213.884 343.846 212.323 345.11 211.18C346.374 210.036 348.008 209.387 349.712 209.351C350.507 209.331 351.298 209.483 352.029 209.797C352.76 210.111 353.414 210.581 353.947 211.172C354.479 211.764 354.877 212.464 355.112 213.224C355.348 213.984 355.416 214.786 355.312 215.575C355.032 218.255 349.055 275.087 348.775 277.767C348.57 279.46 347.761 281.022 346.498 282.166C345.234 283.311 343.6 283.962 341.895 283.999C341.1 284.019 340.309 283.866 339.578 283.551C338.846 283.235 338.192 282.766 337.66 282.173C337.128 281.581 336.73 280.881 336.495 280.12C336.259 279.359 336.191 278.557 336.295 277.767C336.519 275.599 342.6 217.751 342.832 215.575Z",
    fill: "white"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M341.856 224.8C342.4 219.632 342.776 216.08 342.832 215.568C343.037 213.876 343.846 212.315 345.11 211.172C346.374 210.028 348.008 209.379 349.712 209.344C350.507 209.323 351.298 209.475 352.029 209.789C352.76 210.104 353.414 210.573 353.947 211.164C354.479 211.756 354.877 212.456 355.112 213.216C355.348 213.976 355.416 214.779 355.312 215.568C355.032 218.248 349.055 275.08 348.775 277.76C348.57 279.452 347.761 281.014 346.498 282.159C345.234 283.303 343.6 283.954 341.895 283.992C341.1 284.011 340.309 283.858 339.578 283.543C338.846 283.228 338.192 282.758 337.66 282.165C337.128 281.573 336.73 280.873 336.495 280.112C336.259 279.352 336.191 278.549 336.295 277.76C336.455 276.264 339.392 248.32 341.28 230.384",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M316.736 237.688H358.24C361.488 237.77 364.575 239.118 366.843 241.444C369.111 243.77 370.38 246.891 370.38 250.14C370.38 253.388 369.111 256.509 366.843 258.835C364.575 261.161 361.488 262.509 358.24 262.592V308.8C358.24 309.729 357.871 310.62 357.214 311.277C356.557 311.934 355.665 312.304 354.736 312.304H307.784C306.856 312.301 305.967 311.931 305.312 311.274C304.656 310.617 304.288 309.727 304.288 308.8V250.136C304.288 246.834 305.6 243.668 307.934 241.333C310.268 238.999 313.435 237.688 316.736 237.688Z",
    fill: "url(#paint7_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 237,
    width: 67,
    height: 76
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M316.736 237.688H358.24C361.488 237.77 364.575 239.118 366.843 241.444C369.111 243.77 370.38 246.891 370.38 250.14C370.38 253.388 369.111 256.509 366.843 258.835C364.575 261.161 361.488 262.509 358.24 262.592V308.8C358.24 309.729 357.871 310.62 357.214 311.277C356.557 311.934 355.665 312.304 354.736 312.304H307.784C306.856 312.301 305.967 311.931 305.312 311.274C304.656 310.617 304.288 309.727 304.288 308.8V250.136C304.288 246.834 305.6 243.668 307.934 241.333C310.268 238.999 313.435 237.688 316.736 237.688Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M316.736 237.688H358.24C361.488 237.77 364.575 239.118 366.843 241.444C369.111 243.77 370.38 246.891 370.38 250.14C370.38 253.388 369.111 256.509 366.843 258.835C364.575 261.161 361.488 262.509 358.24 262.592V308.8C358.24 309.729 357.871 310.62 357.214 311.277C356.557 311.934 355.665 312.304 354.736 312.304H307.784C306.856 312.301 305.967 311.931 305.312 311.274C304.656 310.617 304.288 309.727 304.288 308.8V250.136C304.288 246.834 305.6 243.668 307.934 241.333C310.268 238.999 313.435 237.688 316.736 237.688Z",
    fill: "white"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M316.736 237.688H358.24C361.488 237.77 364.575 239.118 366.843 241.444C369.111 243.77 370.38 246.891 370.38 250.14C370.38 253.388 369.111 256.509 366.843 258.835C364.575 261.161 361.488 262.509 358.24 262.592V308.8C358.24 309.729 357.871 310.62 357.214 311.277C356.557 311.934 355.665 312.304 354.736 312.304H307.784C306.856 312.301 305.967 311.931 305.312 311.274C304.656 310.617 304.288 309.727 304.288 308.8V250.136C304.288 246.834 305.6 243.668 307.934 241.333C310.268 238.999 313.435 237.688 316.736 237.688Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M236.872 237.688H195.368C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H245.824C246.752 312.301 247.641 311.931 248.296 311.274C248.952 310.617 249.32 309.727 249.32 308.8V250.136C249.32 246.834 248.008 243.668 245.674 241.333C243.34 238.999 240.173 237.688 236.872 237.688Z",
    fill: "url(#paint8_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 237,
    width: 67,
    height: 76
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M236.872 237.688H195.368C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H245.824C246.752 312.301 247.641 311.931 248.296 311.274C248.952 310.617 249.32 309.727 249.32 308.8V250.136C249.32 246.834 248.008 243.668 245.674 241.333C243.34 238.999 240.173 237.688 236.872 237.688Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M236.872 237.688H195.368C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H245.824C246.752 312.301 247.641 311.931 248.296 311.274C248.952 310.617 249.32 309.727 249.32 308.8V250.136C249.32 246.834 248.008 243.668 245.674 241.333C243.34 238.999 240.173 237.688 236.872 237.688Z",
    fill: "white"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M236.872 237.688H195.368C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H245.824C246.752 312.301 247.641 311.931 248.296 311.274C248.952 310.617 249.32 309.727 249.32 308.8V250.136C249.32 246.834 248.008 243.668 245.674 241.333C243.34 238.999 240.173 237.688 236.872 237.688Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M195.368 237.688C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H204.32C205.249 312.304 206.14 311.934 206.798 311.277C207.455 310.62 207.824 309.729 207.824 308.8V250.136C207.822 246.833 206.509 243.667 204.173 241.333C201.837 238.999 198.67 237.687 195.368 237.688Z",
    fill: "url(#paint9_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M195.368 237.688C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H204.32C205.249 312.304 206.14 311.934 206.798 311.277C207.455 310.62 207.824 309.729 207.824 308.8V250.136C207.822 246.833 206.509 243.667 204.173 241.333C201.837 238.999 198.67 237.687 195.368 237.688Z",
    fill: "url(#paint10_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 237,
    width: 25,
    height: 76
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M195.368 237.688C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H204.32C205.249 312.304 206.14 311.934 206.798 311.277C207.455 310.62 207.824 309.729 207.824 308.8V250.136C207.822 246.833 206.509 243.667 204.173 241.333C201.837 238.999 198.67 237.687 195.368 237.688Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M195.368 237.688C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H204.32C205.249 312.304 206.14 311.934 206.798 311.277C207.455 310.62 207.824 309.729 207.824 308.8V250.136C207.822 246.833 206.509 243.667 204.173 241.333C201.837 238.999 198.67 237.687 195.368 237.688Z",
    fill: "white"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M195.368 237.688C192.12 237.77 189.033 239.118 186.765 241.444C184.497 243.77 183.228 246.891 183.228 250.14C183.228 253.388 184.497 256.509 186.765 258.835C189.033 261.161 192.12 262.509 195.368 262.592V308.8C195.368 309.729 195.737 310.62 196.394 311.277C197.051 311.934 197.943 312.304 198.872 312.304H204.32C205.249 312.304 206.14 311.934 206.798 311.277C207.455 310.62 207.824 309.729 207.824 308.8V250.136C207.822 246.833 206.509 243.667 204.173 241.333C201.837 238.999 198.67 237.687 195.368 237.688Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M215.552 292.991V306.743C215.552 308.229 216.142 309.653 217.192 310.703C218.242 311.753 219.667 312.343 221.152 312.343H298.752C300.237 312.343 301.661 311.753 302.712 310.703C303.762 309.653 304.352 308.229 304.352 306.743V282.743C304.353 282.176 304.267 281.612 304.096 281.071C304.263 280.596 304.349 280.096 304.352 279.591V274.791C304.352 274.209 304.237 273.633 304.014 273.095C303.792 272.558 303.465 272.069 303.054 271.657C302.642 271.246 302.154 270.919 301.616 270.697C301.078 270.474 300.502 270.359 299.92 270.359H212.248C211.074 270.361 209.948 270.829 209.119 271.66C208.29 272.491 207.824 273.617 207.824 274.791V279.591C207.824 280.765 208.29 281.892 209.119 282.722C209.948 283.553 211.074 284.021 212.248 284.023H215.552V288.615",
    fill: "url(#paint11_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 270,
    width: 98,
    height: 43
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M215.552 292.991V306.743C215.552 308.229 216.142 309.653 217.192 310.703C218.242 311.753 219.667 312.343 221.152 312.343H298.752C300.237 312.343 301.661 311.753 302.712 310.703C303.762 309.653 304.352 308.229 304.352 306.743V282.743C304.353 282.176 304.267 281.612 304.096 281.071C304.263 280.596 304.349 280.096 304.352 279.591V274.791C304.352 274.209 304.237 273.633 304.014 273.095C303.792 272.558 303.465 272.069 303.054 271.657C302.642 271.246 302.154 270.919 301.616 270.697C301.078 270.474 300.502 270.359 299.92 270.359H212.248C211.074 270.361 209.948 270.829 209.119 271.66C208.29 272.491 207.824 273.617 207.824 274.791V279.591C207.824 280.765 208.29 281.892 209.119 282.722C209.948 283.553 211.074 284.021 212.248 284.023H215.552V288.615",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M304.288 274.727C304.288 273.551 303.821 272.424 302.99 271.593C302.158 270.762 301.031 270.295 299.856 270.295H212.248C211.074 270.297 209.948 270.765 209.119 271.596C208.29 272.427 207.824 273.553 207.824 274.727V279.527C207.824 280.701 208.29 281.827 209.119 282.658C209.948 283.489 211.074 283.957 212.248 283.959H215.552V306.703C215.552 308.188 216.142 309.613 217.192 310.663C218.242 311.713 219.667 312.303 221.152 312.303H298.752C300.237 312.303 301.661 311.713 302.712 310.663C303.762 309.613 304.352 308.188 304.352 306.703V282.703C304.353 282.136 304.267 281.572 304.096 281.031C304.263 280.555 304.349 280.055 304.352 279.551L304.288 274.727Z",
    fill: "white"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.552 292.991V306.743C215.552 308.229 216.142 309.653 217.192 310.703C218.242 311.753 219.667 312.343 221.152 312.343H298.752C300.237 312.343 301.661 311.753 302.712 310.703C303.762 309.653 304.352 308.229 304.352 306.743V282.743C304.353 282.176 304.267 281.612 304.096 281.071C304.263 280.596 304.349 280.096 304.352 279.591V274.791C304.352 274.209 304.237 273.633 304.014 273.095C303.792 272.558 303.465 272.069 303.054 271.657C302.642 271.246 302.154 270.919 301.616 270.697C301.078 270.474 300.502 270.359 299.92 270.359H212.248C211.074 270.361 209.948 270.829 209.119 271.66C208.29 272.491 207.824 273.617 207.824 274.791V279.591C207.824 280.765 208.29 281.892 209.119 282.722C209.948 283.553 211.074 284.021 212.248 284.023H215.552V288.615",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M360.112 250.136H370.688C370.688 253.438 369.377 256.605 367.043 258.941C364.709 261.276 361.542 262.59 358.24 262.592H316.736C320.04 262.592 323.208 261.279 325.544 258.943C327.88 256.608 329.192 253.439 329.192 250.136H355.312",
    fill: "url(#paint12_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 250,
    width: 55,
    height: 13
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M360.112 250.136H370.688C370.688 253.438 369.377 256.605 367.043 258.941C364.709 261.276 361.542 262.59 358.24 262.592H316.736C320.04 262.592 323.208 261.279 325.544 258.943C327.88 256.608 329.192 253.439 329.192 250.136H355.312",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_989_5329)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.192 250.136H370.688C370.688 253.438 369.377 256.605 367.043 258.941C364.709 261.276 361.542 262.59 358.24 262.592H316.736C320.04 262.592 323.208 261.279 325.544 258.943C327.88 256.608 329.192 253.439 329.192 250.136Z",
    fill: "white"
  })))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M360.112 250.136H370.688C370.688 253.438 369.377 256.605 367.043 258.941C364.709 261.276 361.542 262.59 358.24 262.592H316.736C320.04 262.592 323.208 261.279 325.544 258.943C327.88 256.608 329.192 253.439 329.192 250.136H355.312",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M119.2 76.7998H101.784C98.5779 76.7998 95.5032 78.0734 93.2363 80.3403C90.9694 82.6072 89.6958 85.6819 89.6958 88.8878V281.512C89.6958 284.718 90.9694 287.792 93.2363 290.059C95.5032 292.326 98.5779 293.6 101.784 293.6H119.2V76.7998Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9199 109.416H90.6799C89.4428 109.416 88.4399 110.419 88.4399 111.656V125.84C88.4399 127.077 89.4428 128.08 90.6799 128.08H92.9199C94.1571 128.08 95.1599 127.077 95.1599 125.84V111.656C95.1599 110.419 94.1571 109.416 92.9199 109.416Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9199 111.656C92.9199 111.062 92.6839 110.492 92.2639 110.072C91.8438 109.652 91.274 109.416 90.6799 109.416C90.0859 109.416 89.5161 109.652 89.096 110.072C88.6759 110.492 88.4399 111.062 88.4399 111.656V125.84C88.4399 126.434 88.6759 127.004 89.096 127.424C89.5161 127.844 90.0859 128.08 90.6799 128.08C91.274 128.08 91.8438 127.844 92.2639 127.424C92.6839 127.004 92.9199 126.434 92.9199 125.84V111.656Z",
    fill: "url(#paint13_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9199 132.56H90.6799C89.4428 132.56 88.4399 133.562 88.4399 134.8V138.744C88.4399 139.981 89.4428 140.984 90.6799 140.984H92.9199C94.1571 140.984 95.1599 139.981 95.1599 138.744V134.8C95.1599 133.562 94.1571 132.56 92.9199 132.56Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9199 134.8C92.9199 134.205 92.6839 133.636 92.2639 133.216C91.8438 132.796 91.274 132.56 90.6799 132.56C90.0859 132.56 89.5161 132.796 89.096 133.216C88.6759 133.636 88.4399 134.205 88.4399 134.8V138.744C88.4399 139.338 88.6759 139.907 89.096 140.327C89.5161 140.748 90.0859 140.984 90.6799 140.984C91.274 140.984 91.8438 140.748 92.2639 140.327C92.6839 139.907 92.9199 139.338 92.9199 138.744V134.8Z",
    fill: "url(#paint14_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M190.408 76.7998H109.784C103.108 76.7998 97.6958 82.2118 97.6958 88.8878V281.512C97.6958 288.188 103.108 293.6 109.784 293.6H190.408C197.084 293.6 202.496 288.188 202.496 281.512V88.8878C202.496 82.2118 197.084 76.7998 190.408 76.7998Z",
    fill: "url(#paint15_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 76,
    width: 106,
    height: 218
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M190.408 76.7998H109.784C103.108 76.7998 97.6958 82.2118 97.6958 88.8878V281.512C97.6958 288.188 103.108 293.6 109.784 293.6H190.408C197.084 293.6 202.496 288.188 202.496 281.512V88.8878C202.496 82.2118 197.084 76.7998 190.408 76.7998Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M190.408 76.7998H109.784C103.108 76.7998 97.6958 82.2118 97.6958 88.8878V281.512C97.6958 288.188 103.108 293.6 109.784 293.6H190.408C197.084 293.6 202.496 288.188 202.496 281.512V88.8878C202.496 82.2118 197.084 76.7998 190.408 76.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.8239 282.4H40.3359L184.424 84H226.912L82.8239 282.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.552 282.4H91.1602L235.256 84H244.648L100.552 282.4Z",
    fill: "white"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M190.408 76.7998H109.784C103.108 76.7998 97.6958 82.2118 97.6958 88.8878V281.512C97.6958 288.188 103.108 293.6 109.784 293.6H190.408C197.084 293.6 202.496 288.188 202.496 281.512V88.8878C202.496 82.2118 197.084 76.7998 190.408 76.7998Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M190.4 76.7998H109.784C106.578 76.7998 103.503 78.0734 101.236 80.3403C98.9694 82.6072 97.6958 85.6819 97.6958 88.8878V91.1998H202.496V88.8878C202.494 85.6811 201.218 82.6065 198.95 80.3398C196.682 78.0731 193.606 76.7998 190.4 76.7998Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M153.024 86.016C153.308 86.052 153.596 86.0271 153.87 85.9431C154.143 85.859 154.396 85.7177 154.61 85.5285C154.825 85.3393 154.997 85.1066 155.115 84.8458C155.233 84.585 155.294 84.3021 155.294 84.016C155.294 83.7299 155.233 83.447 155.115 83.1862C154.997 82.9254 154.825 82.6927 154.61 82.5035C154.396 82.3143 154.143 82.173 153.87 82.0889C153.596 82.0049 153.308 81.98 153.024 82.016H140.224C139.94 81.98 139.652 82.0049 139.378 82.0889C139.105 82.173 138.852 82.3143 138.638 82.5035C138.423 82.6927 138.251 82.9254 138.133 83.1862C138.015 83.447 137.955 83.7299 137.955 84.016C137.955 84.3021 138.015 84.585 138.133 84.8458C138.251 85.1066 138.423 85.3393 138.638 85.5285C138.852 85.7177 139.105 85.859 139.378 85.9431C139.652 86.0271 139.94 86.052 140.224 86.016H153.024Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M159.936 86.0154C161.049 86.0154 161.952 85.1128 161.952 83.9994C161.952 82.886 161.049 81.9834 159.936 81.9834C158.823 81.9834 157.92 82.886 157.92 83.9994C157.92 85.1128 158.823 86.0154 159.936 86.0154Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6958 273.6V281.512C97.6958 284.718 98.9694 287.792 101.236 290.059C103.503 292.326 106.578 293.6 109.784 293.6H190.4C193.606 293.6 196.682 292.326 198.95 290.06C201.218 287.793 202.494 284.718 202.496 281.512V273.6H97.6958Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M150.096 289.64C153.432 289.64 156.136 286.935 156.136 283.6C156.136 280.264 153.432 277.56 150.096 277.56C146.76 277.56 144.056 280.264 144.056 283.6C144.056 286.935 146.76 289.64 150.096 289.64Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M148.496 157.968C164.119 157.968 176.784 145.303 176.784 129.68C176.784 114.057 164.119 101.392 148.496 101.392C132.873 101.392 120.208 114.057 120.208 129.68C120.208 145.303 132.873 157.968 148.496 157.968Z",
    fill: "#999999"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.096 156.368C165.719 156.368 178.384 143.703 178.384 128.08C178.384 112.457 165.719 99.792 150.096 99.792C134.473 99.792 121.808 112.457 121.808 128.08C121.808 143.703 134.473 156.368 150.096 156.368Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 99,
    width: 58,
    height: 58
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M150.096 156.368C165.719 156.368 178.384 143.703 178.384 128.08C178.384 112.457 165.719 99.792 150.096 99.792C134.473 99.792 121.808 112.457 121.808 128.08C121.808 143.703 134.473 156.368 150.096 156.368Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_989_5329)"
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 160.168L131.328 156.44C130.752 151.92 141.608 146.256 141.608 146.256L152.384 147.896L158.144 143.848C169.648 146.248 167.992 148.552 168.264 151.752C168.416 153.512 168.736 155.48 168.736 155.48L131.8 160.168Z",
    fill: "url(#paint16_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M144.632 130.88C144.632 130.88 147.032 136.288 143.32 145.112L152.368 147.664L156.024 143.496L153.872 133.848L144.632 130.88Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 130,
    width: 14,
    height: 18
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M144.632 130.88C144.632 130.88 147.032 136.288 143.32 145.112L152.368 147.664L156.024 143.496L153.872 133.848L144.632 130.88Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.249 131.76C144.249 131.76 146.929 141.712 156.249 141.36C165.569 141.008 147.265 129.76 147.265 129.76L145.009 129.6L144.249 131.76Z",
    fill: "#263238"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M144.632 130.88C144.632 130.88 147.032 136.288 143.32 145.112L152.368 147.664L156.024 143.496L153.872 133.848L144.632 130.88Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M144.632 130.88C144.632 130.88 140.848 130.496 139.432 118.76C138.28 109.24 144.056 102.832 151.672 102.944C159.832 103.072 164.88 112.344 169.744 112.912C169.744 112.912 164.944 114.96 163.088 113.752C163.088 113.752 166.896 116.952 163.464 118.552C160.032 120.152 144.632 130.88 144.632 130.88Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M163.2 116.168L164.144 123.616C164.144 123.616 165.744 128.672 164.352 132.552C162.96 136.432 161.384 140.808 156.784 139.848C152.184 138.888 148.296 138.76 144.672 130.88L145.664 127.352C145.664 127.352 143.04 127.408 142.6 122.736C142.16 118.064 146.704 120.944 146.704 120.944C147.944 118.731 148.584 116.232 148.56 113.696C148.496 109.536 156.112 116.144 160.608 114.952L157.224 111.336C157.224 111.336 162.176 113.664 163.2 116.168Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M159.033 123.8L161.329 126.96C161.41 127.069 161.465 127.196 161.488 127.331C161.511 127.465 161.502 127.604 161.461 127.734C161.421 127.864 161.35 127.983 161.255 128.081C161.159 128.179 161.042 128.252 160.913 128.296L158.625 129.096",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 131.584C152.528 131.584 154.624 133.48 158.648 132.384",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M153.736 123.456C153.736 124.256 153.496 124.92 153.144 124.928C152.792 124.936 152.496 124.296 152.472 123.496C152.448 122.696 152.712 122.032 153.056 122.016C153.4 122 153.712 122.648 153.736 123.456Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M161.456 123.2C161.456 124 161.216 124.664 160.864 124.672C160.512 124.68 160.216 124.04 160.192 123.24C160.168 122.44 160.424 121.776 160.776 121.768C161.128 121.76 161.432 122.4 161.456 123.2Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M151.08 121.599C151.08 121.599 152.6 118.975 155.968 120.247",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M160 120.12C160 120.12 161.736 118.584 163.272 120.976",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M161.032 110.264C161.575 110.714 162.165 111.103 162.792 111.424",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M143.744 117.408C143.744 117.408 142.88 108.92 148.592 106.12C152.816 104.048 157.32 107.416 160.288 109.696",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M150.744 109.256C152.136 109.256 154.048 110.136 156.592 113.136",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M147.768 111.392C148.021 110.834 148.399 110.341 148.872 109.952",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M139.904 146.855L142.664 144.263L152.048 146.935L156.368 142.527L159.384 143.607L156.512 149.847L152.384 148.359L149.4 151.671L139.904 146.855Z",
    fill: "url(#paint17_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 142,
    width: 21,
    height: 10
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M139.904 146.855L142.664 144.263L152.048 146.935L156.368 142.527L159.384 143.607L156.512 149.847L152.384 148.359L149.4 151.671L139.904 146.855Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.904 146.855L142.664 144.263L152.048 146.935L156.368 142.527L159.384 143.607L156.512 149.847L152.384 148.359L149.4 151.671L139.904 146.855Z",
    fill: "white"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.904 146.855L142.664 144.263L152.048 146.935L156.368 142.527L159.384 143.607L156.512 149.847L152.384 148.359L149.4 151.671L139.904 146.855Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M150.096 156.368C165.719 156.368 178.384 143.703 178.384 128.08C178.384 112.457 165.719 99.792 150.096 99.792C134.473 99.792 121.808 112.457 121.808 128.08C121.808 143.703 134.473 156.368 150.096 156.368Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M170.368 140.983H161.264C158.798 140.983 156.8 142.982 156.8 145.447V154.551C156.8 157.017 158.798 159.015 161.264 159.015H170.368C172.833 159.015 174.832 157.017 174.832 154.551V145.447C174.832 142.982 172.833 140.983 170.368 140.983Z",
    fill: "url(#paint18_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M168.232 146.184C168.105 145.941 167.914 145.738 167.68 145.597C167.446 145.456 167.177 145.382 166.904 145.384H164.736C164.462 145.382 164.194 145.456 163.959 145.597C163.725 145.738 163.534 145.941 163.408 146.184",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M161.976 146.632C161.584 146.632 161.207 146.788 160.93 147.065C160.652 147.343 160.496 147.719 160.496 148.112V153.16C160.496 153.552 160.652 153.929 160.93 154.206C161.207 154.484 161.584 154.64 161.976 154.64H169.656C169.851 154.641 170.044 154.603 170.225 154.53C170.405 154.456 170.57 154.347 170.708 154.209C170.846 154.072 170.956 153.908 171.031 153.728C171.106 153.548 171.144 153.355 171.144 153.16V148.112C171.144 147.917 171.106 147.724 171.031 147.544C170.956 147.364 170.846 147.2 170.708 147.063C170.57 146.925 170.405 146.816 170.225 146.742C170.044 146.668 169.851 146.631 169.656 146.632",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M165.816 148.552C165.403 148.552 164.999 148.674 164.655 148.904C164.312 149.134 164.044 149.461 163.886 149.843C163.728 150.225 163.688 150.645 163.769 151.05C163.85 151.455 164.05 151.827 164.342 152.119C164.635 152.411 165.008 152.609 165.414 152.689C165.819 152.768 166.239 152.726 166.621 152.567C167.002 152.407 167.328 152.138 167.556 151.794C167.784 151.45 167.906 151.045 167.904 150.632C167.905 150.358 167.852 150.086 167.747 149.833C167.642 149.579 167.489 149.349 167.294 149.156C167.1 148.962 166.869 148.809 166.616 148.706C166.362 148.602 166.09 148.55 165.816 148.552Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M185.192 249.248H113.4C109.476 249.248 106.296 252.429 106.296 256.352V262.944C106.296 266.867 109.476 270.048 113.4 270.048H185.192C189.115 270.048 192.296 266.867 192.296 262.944V256.352C192.296 252.429 189.115 249.248 185.192 249.248Z",
    fill: "#999999"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M185.992 246.848H114.2C110.276 246.848 107.096 250.028 107.096 253.952V260.544C107.096 264.467 110.276 267.648 114.2 267.648H185.992C189.915 267.648 193.096 264.467 193.096 260.544V253.952C193.096 250.028 189.915 246.848 185.992 246.848Z",
    fill: "url(#paint19_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M116.104 254.872C116.102 254.436 116.23 254.01 116.471 253.647C116.712 253.284 117.056 253 117.458 252.833C117.861 252.665 118.304 252.621 118.731 252.706C119.159 252.79 119.551 253 119.859 253.308C120.168 253.616 120.377 254.009 120.462 254.437C120.547 254.864 120.502 255.307 120.335 255.71C120.167 256.112 119.884 256.455 119.521 256.697C119.158 256.938 118.732 257.066 118.296 257.064M118.296 249.96C116.993 249.96 115.744 250.477 114.822 251.399C113.901 252.32 113.384 253.569 113.384 254.872C113.384 256.784 115.784 260.68 117.256 262.824C117.37 262.996 117.524 263.136 117.706 263.234C117.887 263.331 118.09 263.382 118.296 263.382C118.502 263.382 118.704 263.331 118.886 263.234C119.067 263.136 119.222 262.996 119.336 262.824C120.8 260.68 123.2 256.8 123.2 254.872C123.2 253.571 122.683 252.322 121.764 251.401C120.844 250.481 119.597 249.962 118.296 249.96Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M176.408 251.424H135.856C135.563 251.424 135.273 251.482 135.002 251.594C134.731 251.706 134.485 251.87 134.278 252.078C134.07 252.285 133.906 252.531 133.794 252.802C133.682 253.072 133.624 253.363 133.624 253.656C133.624 253.949 133.682 254.239 133.794 254.51C133.906 254.781 134.07 255.027 134.278 255.234C134.485 255.441 134.731 255.606 135.002 255.718C135.273 255.83 135.563 255.888 135.856 255.888H176.408C177 255.888 177.568 255.653 177.986 255.234C178.405 254.816 178.64 254.248 178.64 253.656C178.64 253.064 178.405 252.496 177.986 252.078C177.568 251.659 177 251.424 176.408 251.424Z",
    fill: "#858585",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M164.6 258.6H135.856C135.264 258.6 134.696 258.835 134.278 259.253C133.859 259.672 133.624 260.24 133.624 260.832C133.624 261.424 133.859 261.991 134.278 262.41C134.696 262.828 135.264 263.064 135.856 263.064H164.6C165.192 263.064 165.76 262.828 166.178 262.41C166.597 261.991 166.832 261.424 166.832 260.832C166.832 260.24 166.597 259.672 166.178 259.253C165.76 258.835 165.192 258.6 164.6 258.6Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M178.944 258.6H170.728C170.136 258.6 169.568 258.835 169.15 259.253C168.731 259.672 168.496 260.24 168.496 260.832C168.496 261.424 168.731 261.991 169.15 262.41C169.568 262.828 170.136 263.064 170.728 263.064H178.944C179.536 263.064 180.104 262.828 180.522 262.41C180.941 261.991 181.176 261.424 181.176 260.832C181.176 260.24 180.941 259.672 180.522 259.253C180.104 258.835 179.536 258.6 178.944 258.6Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M196.392 223.248H124.6C120.677 223.248 117.496 226.429 117.496 230.352V236.944C117.496 240.867 120.677 244.048 124.6 244.048H196.392C200.316 244.048 203.496 240.867 203.496 236.944V230.352C203.496 226.429 200.316 223.248 196.392 223.248Z",
    fill: "#999999"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M197.192 220.848H125.4C121.476 220.848 118.296 224.028 118.296 227.952V234.544C118.296 238.467 121.476 241.648 125.4 241.648H197.192C201.115 241.648 204.296 238.467 204.296 234.544V227.952C204.296 224.028 201.115 220.848 197.192 220.848Z",
    fill: "url(#paint20_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M125.232 233.487V234.519C125.233 234.598 125.255 234.676 125.295 234.743C125.336 234.811 125.394 234.866 125.464 234.903L129.288 236.975C129.351 237.011 129.423 237.03 129.496 237.03C129.569 237.03 129.64 237.011 129.704 236.975L133.536 234.903C133.605 234.866 133.664 234.811 133.705 234.743C133.745 234.676 133.767 234.598 133.768 234.519V233.487",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M135.672 235.2V230.688L136.768 230.096C136.845 230.06 136.91 230.004 136.955 229.933C137.001 229.862 137.025 229.78 137.025 229.696C137.025 229.611 137.001 229.529 136.955 229.458C136.91 229.387 136.845 229.331 136.768 229.296L129.704 225.472C129.641 225.436 129.569 225.417 129.496 225.417C129.423 225.417 129.352 225.436 129.288 225.472L122.232 229.296C122.156 229.331 122.091 229.387 122.045 229.458C122 229.529 121.976 229.611 121.976 229.696C121.976 229.78 122 229.862 122.045 229.933C122.091 230.004 122.156 230.06 122.232 230.096L129.288 233.912C129.352 233.947 129.423 233.966 129.496 233.966C129.569 233.966 129.641 233.947 129.704 233.912L133.768 231.72",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M187.608 225.424H147.056C146.464 225.424 145.897 225.659 145.478 226.078C145.059 226.496 144.824 227.064 144.824 227.656C144.824 228.248 145.059 228.816 145.478 229.234C145.897 229.653 146.464 229.888 147.056 229.888H187.608C188.2 229.888 188.768 229.653 189.186 229.234C189.605 228.816 189.84 228.248 189.84 227.656C189.84 227.064 189.605 226.496 189.186 226.078C188.768 225.659 188.2 225.424 187.608 225.424Z",
    fill: "#858585",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.6 232.6H147.056C146.464 232.6 145.897 232.835 145.478 233.253C145.059 233.672 144.824 234.24 144.824 234.832C144.824 235.424 145.059 235.991 145.478 236.41C145.897 236.828 146.464 237.064 147.056 237.064H168.6C169.192 237.064 169.76 236.828 170.178 236.41C170.597 235.991 170.832 235.424 170.832 234.832C170.832 234.24 170.597 233.672 170.178 233.253C169.76 232.835 169.192 232.6 168.6 232.6Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M183.128 232.6H174.912C174.32 232.6 173.752 232.835 173.334 233.253C172.915 233.672 172.68 234.24 172.68 234.832C172.68 235.424 172.915 235.991 173.334 236.41C173.752 236.828 174.32 237.064 174.912 237.064H183.128C183.72 237.064 184.288 236.828 184.706 236.41C185.125 235.991 185.36 235.424 185.36 234.832C185.36 234.24 185.125 233.672 184.706 233.253C184.288 232.835 183.72 232.6 183.128 232.6Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M174.792 197.248H103C99.0766 197.248 95.896 200.429 95.896 204.352V210.944C95.896 214.867 99.0766 218.048 103 218.048H174.792C178.715 218.048 181.896 214.867 181.896 210.944V204.352C181.896 200.429 178.715 197.248 174.792 197.248Z",
    fill: "#999999"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M175.592 194.848H103.8C99.8764 194.848 96.6958 198.028 96.6958 201.952V208.544C96.6958 212.467 99.8764 215.648 103.8 215.648H175.592C179.515 215.648 182.696 212.467 182.696 208.544V201.952C182.696 198.028 179.515 194.848 175.592 194.848Z",
    fill: "url(#paint21_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M108.232 206.12H107.56C107.118 206.12 106.76 206.478 106.76 206.92V208.64C106.76 209.082 107.118 209.44 107.56 209.44H108.232C108.674 209.44 109.032 209.082 109.032 208.64V206.92C109.032 206.478 108.674 206.12 108.232 206.12Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M102.448 208.439C102.448 209.099 102.71 209.732 103.176 210.199C103.643 210.665 104.276 210.927 104.936 210.927H110.864C111.524 210.927 112.156 210.665 112.623 210.199C113.09 209.732 113.352 209.099 113.352 208.439",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M103.952 201.064H103.152C102.809 201.066 102.48 201.203 102.238 201.446C101.995 201.688 101.858 202.017 101.856 202.36V204.944C101.855 205.278 101.92 205.608 102.047 205.917C102.174 206.226 102.36 206.506 102.596 206.742C102.832 206.979 103.111 207.166 103.42 207.294C103.728 207.422 104.058 207.488 104.392 207.488H105.192M110.64 207.488H111.4C112.075 207.488 112.722 207.22 113.199 206.743C113.676 206.266 113.944 205.619 113.944 204.944V202.4C113.942 202.057 113.805 201.728 113.562 201.486C113.319 201.243 112.991 201.106 112.648 201.104H111.848M105.8 201.104V200.8C105.802 200.477 105.932 200.167 106.161 199.94C106.391 199.712 106.701 199.584 107.024 199.584H108.8C109.119 199.59 109.423 199.721 109.647 199.948C109.871 200.175 109.998 200.481 110 200.8V201.088",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M166.008 199.424H125.456C124.864 199.424 124.296 199.659 123.878 200.078C123.459 200.496 123.224 201.064 123.224 201.656C123.224 202.248 123.459 202.816 123.878 203.234C124.296 203.653 124.864 203.888 125.456 203.888H166.008C166.6 203.888 167.168 203.653 167.586 203.234C168.005 202.816 168.24 202.248 168.24 201.656C168.24 201.064 168.005 200.496 167.586 200.078C167.168 199.659 166.6 199.424 166.008 199.424Z",
    fill: "#858585",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M159 206.6H125.456C124.864 206.6 124.296 206.835 123.878 207.253C123.459 207.672 123.224 208.24 123.224 208.832C123.224 209.424 123.459 209.991 123.878 210.41C124.296 210.828 124.864 211.064 125.456 211.064H159C159.592 211.064 160.16 210.828 160.578 210.41C160.997 209.991 161.232 209.424 161.232 208.832C161.232 208.24 160.997 207.672 160.578 207.253C160.16 206.835 159.592 206.6 159 206.6Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M255.32 314.017L255.064 320.625C255.064 320.625 247.592 325.609 244.328 326.689C242.728 327.217 238.384 327.777 238.384 329.753C238.384 331.729 243.984 332.017 247.016 332.017C248.616 332.017 252.68 331.865 257.72 331.809C262.264 331.761 266.288 331.137 266.288 328.961C266.203 326.017 265.378 323.142 263.888 320.601L264.84 314.017H255.32Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M256.216 199.585C256.216 199.585 255.056 217.665 255.296 230.497C255.48 240.769 253.448 270.769 253.448 270.769L254.248 316.089L265.392 316.889C265.392 316.889 271.352 292.665 270.04 271.289C270.04 271.289 274.472 241.417 275.8 231.817C275.8 231.817 284.776 220.073 284.416 199.385L256.216 199.585Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M261.328 216C262.921 219.438 265.343 222.426 268.376 224.696",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M238.4 329.745C238.4 331.721 244 332.017 247.032 332.017C248.632 332.017 252.696 331.865 257.736 331.809C262.28 331.761 266.304 331.137 266.304 328.961C266.219 326.017 265.393 323.141 263.904 320.601C261.76 321.401 260.952 324.321 260.952 324.321C260.952 324.321 255.256 325.217 256.752 323.209C258.248 321.201 255.048 320.625 255.048 320.625C255.048 320.625 247.576 325.609 244.312 326.689C242.744 327.201 238.4 327.777 238.4 329.745Z",
    fill: "url(#paint22_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M253.448 313.368L253.672 317.168L265.92 318.216L266.968 314.392L253.448 313.368Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M261.552 268.561C263.165 269.81 265.004 270.737 266.968 271.289C272.656 272.889 261.504 273.289 261.08 275.489",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M258.784 265.688C259.163 266.243 259.595 266.76 260.072 267.232",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M234.568 181.36L228.08 185.824C227.047 185.016 225.776 184.571 224.464 184.56C222.52 184.656 220.624 185.68 219.32 185.824C217.824 185.976 213.368 185.144 213.368 186.528C213.368 188.56 220.984 187.808 221.224 188.76C221.464 189.712 216.168 191.056 216.168 191.056L215.52 192.312L226.064 193.312C226.064 193.312 230.72 193.808 232.92 190.656L241.32 185.856L236.264 179.944L234.568 181.36Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M256.112 138.4C253.592 145.768 250.968 168.184 250.968 168.184L232.8 181.288L238.4 188.288C238.4 188.288 256.464 179.248 259.344 177.024C262.224 174.8 265.632 151.048 267.416 146.304C269.2 141.56 268.136 136.52 263.568 134.64C259 132.76 256.8 136.432 256.112 138.4Z",
    fill: "url(#paint23_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M231.096 180.497L234.824 177.337L242.328 187.577L238.192 190.081L231.096 180.497Z",
    fill: "url(#paint24_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 177,
    width: 12,
    height: 14
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M231.096 180.497L234.824 177.337L242.328 187.577L238.192 190.081L231.096 180.497Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M231.096 180.497L234.824 177.337L242.328 187.577L238.192 190.081L231.096 180.497Z",
    fill: "white"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M231.096 180.497L234.824 177.337L242.328 187.577L238.192 190.081L231.096 180.497Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M268.2 126.832L283.648 124.736L271.152 132.752L268.872 133.12L268.2 126.832Z",
    fill: "url(#paint25_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M268.48 123.897C268.48 123.897 263.112 125.889 261.92 122.153C261.195 119.882 260.791 117.52 260.72 115.137L258.744 114.033C258.626 113.968 258.522 113.879 258.44 113.772C258.359 113.665 258.3 113.542 258.268 113.411C258.237 113.28 258.233 113.144 258.257 113.011C258.281 112.879 258.332 112.752 258.408 112.641L261.52 108.041C261.52 108.041 260.616 104.713 261.12 102.969C261.624 101.225 264.032 95.8169 264.032 95.8169C264.032 95.8169 275.792 86.7209 281.808 96.4169C287.824 106.113 279.888 119.025 279.888 119.025L281.808 128.521L270.448 134.121L268.48 123.897Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 91,
    width: 27,
    height: 44
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M268.48 123.897C268.48 123.897 263.112 125.889 261.92 122.153C261.195 119.882 260.791 117.52 260.72 115.137L258.744 114.033C258.626 113.968 258.522 113.879 258.44 113.772C258.359 113.665 258.3 113.542 258.268 113.411C258.237 113.28 258.233 113.144 258.257 113.011C258.281 112.879 258.332 112.752 258.408 112.641L261.52 108.041C261.52 108.041 260.616 104.713 261.12 102.969C261.624 101.225 264.032 95.8169 264.032 95.8169C264.032 95.8169 275.792 86.7209 281.808 96.4169C287.824 106.113 279.888 119.025 279.888 119.025L281.808 128.521L270.448 134.121L268.48 123.897Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.48 123.897C270.334 123.104 272.051 122.024 273.568 120.697C273.629 120.642 273.707 120.609 273.789 120.603C273.871 120.598 273.953 120.62 274.021 120.666C274.089 120.712 274.14 120.779 274.165 120.857C274.19 120.936 274.188 121.02 274.16 121.097C273.051 124.129 271.076 126.769 268.48 128.689C263.416 132.417 268.48 123.897 268.48 123.897Z",
    fill: "#999999"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M268.48 123.897C268.48 123.897 263.112 125.889 261.92 122.153C261.195 119.882 260.791 117.52 260.72 115.137L258.744 114.033C258.626 113.968 258.522 113.879 258.44 113.772C258.359 113.665 258.3 113.542 258.268 113.411C258.237 113.28 258.233 113.144 258.257 113.011C258.281 112.879 258.332 112.752 258.408 112.641L261.52 108.041C261.52 108.041 260.616 104.713 261.12 102.969C261.624 101.225 264.032 95.8169 264.032 95.8169C264.032 95.8169 275.792 86.7209 281.808 96.4169C287.824 106.113 279.888 119.025 279.888 119.025L281.808 128.521L270.448 134.121L268.48 123.897Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M262.072 103.504C262.072 103.504 263.992 101.816 266.072 104.616",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M264 116.481C264 116.481 265.408 117.497 267.592 115.761",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M264.488 107.032C264.488 107.592 264.216 108.04 263.888 108.04C263.56 108.04 263.28 107.592 263.28 107.032C263.28 106.472 263.552 106.024 263.888 106.024C264.224 106.024 264.488 106.48 264.488 107.032Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M273.96 108.04C273.96 108.04 275.768 104.616 278.08 107.032C281.664 110.784 276.352 113.52 276.352 113.52C276.908 115.688 278.148 117.618 279.888 119.024C279.888 119.024 281.352 117.424 282.984 115.416C284.616 113.408 289.056 106.112 285.888 97.9125C285.888 97.9125 286.216 90.3365 274.688 88.8245C263.16 87.3125 261.936 93.0645 258.216 92.4885C258.216 92.4885 261.048 95.0165 263.856 93.1925C263.6 93.8606 263.158 94.4415 262.583 94.8668C262.007 95.292 261.322 95.5438 260.608 95.5925C260.608 95.5925 264.088 98.5685 267.592 97.7925C271.096 97.0165 269.6 102.568 273.96 108.04Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M282.984 96.3682C283.338 97.0388 283.607 97.751 283.784 98.4882",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M266.664 91.145C266.664 91.145 277.064 89.545 281.776 94.681",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M267.2 94.9521C266.56 95.0401 265.896 95.1681 265.2 95.3201",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M281.809 100.001C281.809 100.001 278.969 94.2808 269.729 94.6888",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M281.528 114.729C281.24 115.233 280.928 115.745 280.584 116.265",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M284.104 102.585C284.65 106.142 284.063 109.781 282.424 112.985",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M287.368 315.617L287.92 320.625C287.92 320.625 280.448 325.609 277.184 326.689C275.584 327.217 271.232 327.777 271.232 329.753C271.232 331.729 276.832 332.017 279.872 332.017C281.472 332.017 285.528 331.865 290.568 331.809C295.12 331.761 299.136 331.137 299.136 328.961C299.051 326.017 298.226 323.141 296.736 320.601L296.44 314.393L287.368 315.617Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 324.521C290.4 324.521 289.504 323.817 289.504 323.817C291.504 322.121 287.952 320.617 287.952 320.617C287.952 320.617 280.48 325.601 277.216 326.681C275.616 327.209 271.264 327.769 271.264 329.737C271.264 331.705 276.864 332.009 279.904 332.009C281.504 332.009 285.56 331.857 290.6 331.801C295.152 331.753 299.168 331.129 299.168 328.953C299.082 326.009 298.257 323.134 296.768 320.593C294.072 321.689 295.2 324.521 292.8 324.521Z",
    fill: "url(#paint26_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M268.488 199.688H293.288C293.288 199.688 296.264 214.528 295.384 229.288C294.504 244.048 295.76 269.552 295.76 269.552C295.76 269.552 298.816 282.552 297.168 316.872L286.96 317.672C286.96 317.672 279.688 283.768 278.232 270.472C277.368 262.536 275.344 241.672 273.32 233.928C271.2 225.96 269.208 222.944 268.488 199.688Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M293.84 311.28C293.84 312.288 293.904 313.328 293.936 314.392",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M288.864 243.152C289.248 252.24 289.48 263.736 290.2 270.216C291.328 280.32 292.856 285.2 293.72 307.816",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M280.336 210.4C281.501 213.528 283.78 216.115 286.736 217.664C286.736 217.664 287.536 225.664 288.336 234.192C288.464 235.528 288.568 237.096 288.664 238.84",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M278.832 204.473C278.961 205.754 279.21 207.021 279.576 208.257",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M268.728 207.408C268.691 206.587 268.651 205.723 268.608 204.816",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M270.648 224.648C269.678 219.955 269.092 215.189 268.896 210.4",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M274.312 238.865C273.968 236.937 273.632 235.249 273.288 233.945C272.816 232.161 272.352 229.905 271.912 228.465",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M285.216 315.112L286.048 318.832L298.304 317.88L298.704 314.152L285.216 315.112Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M294.4 167.041C294.656 150.817 300.264 133.073 300.264 133.073C300.264 133.073 294.936 127.129 283.832 126.057L271.456 133.465L268.856 133.121L267.816 128.121C260.72 130.881 256.104 135.793 255.52 140.777C254.64 148.209 256.856 170.601 256.056 185.033C255.576 193.633 255 202.633 255 202.633L264.968 204.793L266.76 202.345L269.736 204.793L295.8 202.145C295.8 202.145 294.16 183.265 294.4 167.041Z",
    fill: "url(#paint27_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M268.488 126.416L269.992 132.272L283.672 124.328L287 126.064L276.312 136.456L269.832 133.336L265.24 135.792L265.736 128.16L268.488 126.416Z",
    fill: "url(#paint28_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 124,
    width: 22,
    height: 13
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M268.488 126.416L269.992 132.272L283.672 124.328L287 126.064L276.312 136.456L269.832 133.336L265.24 135.792L265.736 128.16L268.488 126.416Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M268.488 126.416L269.992 132.272L283.672 124.328L287 126.064L276.312 136.456L269.832 133.336L265.24 135.792L265.736 128.16L268.488 126.416Z",
    fill: "white"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M268.488 126.416L269.992 132.272L283.672 124.328L287 126.064L276.312 136.456L269.832 133.336L265.24 135.792L265.736 128.16L268.488 126.416Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M266.832 196.616C266.832 198.448 266.832 199.384 266.832 199.384",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M268.608 141.545C267.454 150.123 266.874 158.769 266.872 167.425C266.744 180.145 266.776 189.345 266.816 194.521",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M269.417 136.977C269.417 136.977 269.225 137.777 268.937 139.465",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M253.288 163.513H181.496C177.573 163.513 174.392 166.693 174.392 170.617V185.209C174.392 189.132 177.573 192.313 181.496 192.313H253.288C257.212 192.313 260.392 189.132 260.392 185.209V170.617C260.392 166.693 257.212 163.513 253.288 163.513Z",
    fill: "url(#paint29_linear_989_5329)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M185.136 178.137L182.048 175.297L187.072 169.785C187.337 169.52 187.697 169.371 188.072 169.371C188.447 169.371 188.806 169.52 189.072 169.785L189.984 170.633C190.271 170.875 190.451 171.222 190.484 171.596C190.517 171.971 190.401 172.344 190.16 172.633L185.136 178.137Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M183.08 179.44L180.632 179.96L180.928 177.456",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M241.992 168.841H201.44C200.848 168.841 200.28 169.076 199.862 169.495C199.443 169.913 199.208 170.481 199.208 171.073C199.208 171.665 199.443 172.232 199.862 172.651C200.28 173.07 200.848 173.305 201.44 173.305H241.992C242.584 173.305 243.152 173.07 243.57 172.651C243.989 172.232 244.224 171.665 244.224 171.073C244.224 170.481 243.989 169.913 243.57 169.495C243.152 169.076 242.584 168.841 241.992 168.841Z",
    fill: "#858585",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M234.984 176H201.44C200.848 176 200.28 176.235 199.862 176.654C199.443 177.072 199.208 177.64 199.208 178.232C199.208 178.824 199.443 179.392 199.862 179.81C200.28 180.229 200.848 180.464 201.44 180.464H234.984C235.576 180.464 236.144 180.229 236.562 179.81C236.981 179.392 237.216 178.824 237.216 178.232C237.216 177.64 236.981 177.072 236.562 176.654C236.144 176.235 235.576 176 234.984 176Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M275.472 181.968C275.472 181.968 265.304 184.664 264.08 185.04C262.856 185.416 261.472 187.488 259.888 189.424C258.674 191.031 257 192.231 255.088 192.864C253.784 193.168 250.088 194.464 250.04 193.368C249.992 192.272 253.768 191.92 253.768 191.92L256.896 190.368C255.296 191.376 249.648 192.24 249.648 192.24C248.817 192.363 247.97 192.196 247.248 191.768C246.144 191.064 246.808 190.232 246.808 190.232C246.4 189.368 248.248 188.864 248.248 188.864L251.648 186.6C251.648 186.6 254.344 182.664 253.848 181.968C253.352 181.272 248.32 183.624 247.704 182.464C247.088 181.304 251.648 179.664 254.248 179.048C256.848 178.432 261.04 179.048 261.04 179.048L272.8 174.664L275.472 181.968Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M248.04 190.4C248.525 190.403 249.01 190.363 249.488 190.28C250.785 189.77 251.991 189.051 253.056 188.152C253.856 187.424 254.656 186.016 255.256 185.912",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M248.584 191.369C249.093 191.344 249.594 191.241 250.072 191.065C251.498 190.657 252.885 190.121 254.216 189.465C255.016 188.953 256.056 187.865 256.616 187.969",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M288 140.944C287.952 138.128 288.064 130.544 295.656 131.096C303.248 131.648 302.456 139.576 302.192 145.096C301.928 150.616 304.288 173.736 299.168 175.392L271.864 184.192L268.464 174.408L288.992 165.816C288.992 165.816 288.12 147.2 288 140.944Z",
    fill: "url(#paint30_linear_989_5329)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M296.696 170.601C297.066 171.096 297.378 171.633 297.624 172.201",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 165.24C297.6 165.24 292.096 163.56 291.272 165.688C290.648 167.288 293.368 167.464 295.632 169.472",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M288.072 143.152C288.072 142.312 288.072 141.552 288.024 140.944",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M295.68 131.097C303.272 131.617 302.48 139.577 302.216 145.097C301.952 150.617 304.312 173.737 299.192 175.393L271.888 184.193L268.488 174.409L289.016 165.817C289.016 165.817 288.424 153.457 288.152 145.489",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M266.872 174.121L271.368 172.217L275.472 184.233L270.768 185.393L266.872 174.121Z",
    fill: "url(#paint31_linear_989_5329)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_989_5329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 172,
    width: 10,
    height: 14
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M266.872 174.121L271.368 172.217L275.472 184.233L270.768 185.393L266.872 174.121Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_989_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M266.872 174.121L271.368 172.217L275.472 184.233L270.768 185.393L266.872 174.121Z",
    fill: "white"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M266.872 174.121L271.368 172.217L275.472 184.233L270.768 185.393L266.872 174.121Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M215.328 191.792C215.112 190.944 214.664 188.52 215.968 188.52C217.272 188.52 217.512 189.96 217.512 189.96C217.512 189.96 217.288 188.272 218.568 188.52C219.848 188.768 220.048 190.664 220.048 190.664C220.048 190.664 219.832 189.128 221.224 189.288C222.616 189.448 221.784 192.944 223.448 192.928C224.152 192.928 223.336 190.432 224.696 190.44C226.056 190.448 225.496 193.128 228.048 193.128C228.848 193.128 225.744 194.2 223.68 193.76C223.68 193.76 222.72 194.632 220.248 193.264C219.806 193.472 219.312 193.545 218.828 193.474C218.344 193.403 217.892 193.191 217.528 192.864C217.32 192.992 217.083 193.066 216.839 193.078C216.595 193.09 216.352 193.041 216.133 192.934C215.913 192.827 215.724 192.666 215.584 192.466C215.443 192.267 215.355 192.035 215.328 191.792Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M217.488 190.969C217.457 191.257 217.484 191.548 217.568 191.825",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M220.12 191.625C220.12 191.625 220.072 191.577 220.216 192.241",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_989_5329",
    x1: 200.677,
    y1: 60.0195,
    x2: 200.677,
    y2: 296.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_989_5329",
    x1: 202.592,
    y1: 324.84,
    x2: 202.592,
    y2: 339.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_989_5329",
    x1: 49.8594,
    y1: 150.729,
    x2: 49.8594,
    y2: 201.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_989_5329",
    x1: 86.1032,
    y1: 212.071,
    x2: 86.1032,
    y2: 241.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_989_5329",
    x1: 48.7135,
    y1: 203.681,
    x2: 48.7135,
    y2: 243.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_989_5329",
    x1: 297.908,
    y1: 209.352,
    x2: 297.908,
    y2: 284.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_989_5329",
    x1: 345.804,
    y1: 209.342,
    x2: 345.804,
    y2: 283.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_989_5329",
    x1: 337.334,
    y1: 237.688,
    x2: 337.334,
    y2: 312.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_989_5329",
    x1: 216.274,
    y1: 237.688,
    x2: 216.274,
    y2: 312.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_989_5329",
    x1: 195.526,
    y1: 237.688,
    x2: 195.526,
    y2: 312.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_989_5329",
    x1: 195.526,
    y1: 237.688,
    x2: 195.526,
    y2: 312.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_989_5329",
    x1: 256.088,
    y1: 270.359,
    x2: 256.088,
    y2: 312.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_989_5329",
    x1: 343.712,
    y1: 250.136,
    x2: 343.712,
    y2: 262.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_989_5329",
    x1: 90.6799,
    y1: 109.416,
    x2: 90.6799,
    y2: 128.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_989_5329",
    x1: 90.6799,
    y1: 132.56,
    x2: 90.6799,
    y2: 140.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_989_5329",
    x1: 150.096,
    y1: 76.7998,
    x2: 150.096,
    y2: 293.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_989_5329",
    x1: 150.021,
    y1: 143.848,
    x2: 150.021,
    y2: 160.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_989_5329",
    x1: 149.644,
    y1: 142.527,
    x2: 149.644,
    y2: 151.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_989_5329",
    x1: 165.816,
    y1: 140.983,
    x2: 165.816,
    y2: 159.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_989_5329",
    x1: 150.096,
    y1: 246.848,
    x2: 150.096,
    y2: 267.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_989_5329",
    x1: 161.296,
    y1: 220.848,
    x2: 161.296,
    y2: 241.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_989_5329",
    x1: 139.696,
    y1: 194.848,
    x2: 139.696,
    y2: 215.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_989_5329",
    x1: 252.352,
    y1: 320.601,
    x2: 252.352,
    y2: 332.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_989_5329",
    x1: 250.518,
    y1: 134.12,
    x2: 250.518,
    y2: 188.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_989_5329",
    x1: 236.712,
    y1: 177.337,
    x2: 236.712,
    y2: 190.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_989_5329",
    x1: 275.924,
    y1: 124.736,
    x2: 275.924,
    y2: 133.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_989_5329",
    x1: 285.216,
    y1: 320.593,
    x2: 285.216,
    y2: 332.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_989_5329",
    x1: 277.632,
    y1: 126.057,
    x2: 277.632,
    y2: 204.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_989_5329",
    x1: 276.12,
    y1: 124.328,
    x2: 276.12,
    y2: 136.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_989_5329",
    x1: 217.392,
    y1: 163.513,
    x2: 217.392,
    y2: 192.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_989_5329",
    x1: 285.487,
    y1: 131.067,
    x2: 285.487,
    y2: 184.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_989_5329",
    x1: 271.172,
    y1: 172.217,
    x2: 271.172,
    y2: 185.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.056cf5e527e72c95c94c802328717e8e.svg";
export { ForwardRef as ReactComponent };